module.exports = __webpack_public_path__ + "static/media/orderbox.5b369416.png";